// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getProductListDataViewProperty } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Download from "@store/Library/Components/Toolkit/Icons/Download";
import Button, { ButtonPresentationProps } from "@store/MobiusOverrides/Button/Button";
import { getDocumentsWrapper } from "@store/Framework/Common/Utilities/getDocumentsWrapper";
import { getExportPriceList } from "@store/Framework/Services/documentService";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import withHookProps, { HookPropsInjector } from "@toolkit/Framework/Common/Utilities/withHookProps";
import React, { FC, useState } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    trackPriceListExport: ReturnType<typeof ga.use.trackPriceListExport>;
}
const hookPropsInjector: HookPropsInjector<Props, OwnProps> = () => ({
    trackPriceListExport: ga.use.trackPriceListExport(),
});

const mapStateToProps = (state: ApplicationState) => ({
    hasProducts: getProductListDataViewProperty(state, "pagination")?.totalItemCount,
});

type Props = OwnProps & WidgetProps & ReturnType<typeof mapStateToProps>;

interface ProductListExportPriceListStyles {
    button?: ButtonPresentationProps;
}

const productListExportPriceListStyles: ProductListExportPriceListStyles = {
    button: {
        variant: "tertiary",
        icon: {
            src: Download,
            position: "left",
        },
        typographyProps: {
            css: css`
                white-space: nowrap;
            `,
        },
    },
};

const styles = productListExportPriceListStyles;

const ProductListExportPriceList = ({ hasProducts, trackPriceListExport }: Props) => {
    const toasterContext = React.useContext(ToasterContext);
    const [isLoadingPriceListExport, setIsLoadingPriceListExport] = useState<boolean>(false);

    const handleExportPriceListClick = async () => {
        await getDocumentsWrapper(getExportPriceList, setIsLoadingPriceListExport, {}, toasterContext);
        trackPriceListExport({ file_export: "Price List" });
    };

    if (!hasProducts) {
        return null;
    }

    return (
        <StyledWrapper>
            <Button
                {...styles.button}
                onClick={handleExportPriceListClick}
                disabled={!hasProducts}
                isLoading={isLoadingPriceListExport}
            >
                {translate("Download Price List")}
            </Button>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, null)(withHookProps(ProductListExportPriceList, hookPropsInjector)),
    definition: {
        group: "Product List",
        displayName: "Download Price List Button",
        allowedContexts: ["ProductListPage"],
    },
};

export default widgetModule;
